import { cn } from '@discover-lib/utils';

export type RestaurantCardRootProps = React.ComponentPropsWithoutRef<'div'> & { visible: boolean };

export default function RestaurantCardRoot({
  visible,
  className,
  ...props
}: RestaurantCardRootProps) {
  return (
    <div
      className={cn(
        'pointer-events-none flex w-full max-w-full flex-col items-center justify-center transition-transform',
        { 'translate-y-full': !visible },
        className
      )}
      {...props}
    />
  );
}
